module.exports = __webpack_public_path__ + "a5de44c80f75d694f9372742ebe230d2.pdf";